module.exports = __webpack_public_path__ + "pattern5.372dee6df561fd2ed153.png";


//////////////////
// WEBPACK FOOTER
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/assets/images/pattern5.png
// module id = ../../../../../src/assets/images/pattern5.png
// module chunks = styles